import { useEffect, useState } from 'react';
import type { Expense } from '@/lib/types';
import { useRepositories } from '@/context/RepositoryContext';
import { invalidateExpenses, subscribeExpenses } from './expensesStore';

export function useExpense(expenseId: string | undefined): { expense: Expense | null; loading: boolean; reload: () => void } {
  const { expenseRepository } = useRepositories();
  const [expense, setExpense] = useState<Expense | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!expenseId) return;
    let active = true;
    const load = () => {
      expenseRepository.getExpenseById(expenseId).then((data) => {
        if (!active) return;
        setExpense(data);
        setLoading(false);
      });
    };
    load();
    const unsubscribe = subscribeExpenses(load);
    return () => {
      active = false;
      unsubscribe();
    };
  }, [expenseId, expenseRepository]);

  return { expense, loading, reload: invalidateExpenses };
}
